module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "line",
    attrs: {
      "id": "blueline1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/blueline.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Whenever yet another white person murders a black person on video and doesn’t even get in trouble, the first thing you ask me is, "), _c('i', [_vm._v("Why are you so angry?")]), _vm._v(" Keep that to yourself, or say what you mean: "), _c('i', [_vm._v("How did you notice that we are killing you?")])]), _vm._v(" "), _c('p', {
    staticClass: "line",
    attrs: {
      "id": "blueline2"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/blueline.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c4d8f90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/chap4.vue
// module id = 81
// module chunks = 0